import { BoxComponent } from '../../../../../base/box/Box';
import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { getScaleSize } from '../../../../../utils/utils';

interface Header {
  scale?: number;
  children: React.ReactNode;
  isLayoutOne: boolean;
}

const Header = ({ scale = 1, children, isLayoutOne }: Header) => {
  const { normalizePixels } = useNormalizedPixels();

  return (
    <BoxComponent
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: getScaleSize(normalizePixels(50, 'height'), scale),
        padding: isLayoutOne
          ? `
        ${getScaleSize(normalizePixels(35, 'height'), scale)} 
        ${getScaleSize(normalizePixels(51, 'width'), scale)} 
        ${getScaleSize(normalizePixels(0, 'height'), scale)} 
        ${getScaleSize(normalizePixels(51, 'width'), scale)}`
          : '0px',
        lineHeight: 'normal',
      }}
    >
      {children}
    </BoxComponent>
  );
};

export default Header;
